import { render, staticRenderFns } from "./RefsDupes.vue?vue&type=template&id=26ab1626"
import script from "./RefsDupes.vue?vue&type=script&lang=js"
export * from "./RefsDupes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports